module.exports = __webpack_public_path__ + "tf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/tf.svg
// module id = 1089
// module chunks = 0